// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

import { type DeprecatedReduxState } from "./types";

export function useCurrentUserId() {
  const profile = useSelector((state: DeprecatedReduxState) => state.session.profile);

  return profile?.userId;
}
